module.exports = __webpack_public_path__ + "static/media/YM41_0.4d103a2a.jpg";